module.exports = __webpack_public_path__ + "img/background-53.6dc644ef.png";